export default {
  baseURL: !process.env.REACT_APP_API_URL
    ? !process.env.NODE_ENV || process.env.NODE_ENV === "development"
      ? "https://fidelidade-dev-2.leroymerlin.com.br"
      : window.location.hostname === "fidelidade-qas-1.leroymerlin.com.br"
      ? "https://fidelidade-qas-2.leroymerlin.com.br"
      : window.location.hostname === "fidelidade-backoffice.leroymerlin.com.br"
      ? "https://fidelidade-backoffice-2.leroymerlin.com.br"
      : "https://fidelidade-dev-2.leroymerlin.com.br"
    : process.env.REACT_APP_API_URL,
};
